/// <reference types="vite-plugin-svgr/client" />

import classNames from 'classnames';
import * as React from 'react';

import BackgroundIcon from './icons/background-icon.png';
import ChatterGrey from './icons/chatter-grey.png';
import DashboardImg from './icons/dashboard.png';
import HiddenContent from './icons/hidden-content.png';
import ImageSelection from './icons/image_selection_in_component.png';
import ListSelection from './icons/list_selection_in_component.png';
import ParagraphSelection from './icons/paragraph_selection_in_component.png';
import ImagePlaceholder from './icons/placeholder-photo.png';
import ReferralsImg from './icons/referrals.png';
import TitleSelection from './icons/title_selection_in_component.png';

import AccountManagement from './icons/account-management.svg?react';
import AddPage from './icons/add-page.svg?react';
import AdvancedMenu from './icons/advanced-menu.svg?react';
import AlignCenter from './icons/align-center.svg?react';
import AlignJustify from './icons/align-justify.svg?react';
import AlignLeft from './icons/align-left.svg?react';
import AlignRight from './icons/align-right.svg?react';
import AlignmentBottom from './icons/alignment-bottom.svg?react';
import AlignmentCentre from './icons/alignment-centre.svg?react';
import AlignmentLeft from './icons/alignment-left.svg?react';
import AlignmentMiddle from './icons/alignment-middle.svg?react';
import AlignmentRight from './icons/alignment-right.svg?react';
import AlignmentTop from './icons/alignment-top.svg?react';
import ArrowDownLong from './icons/arrow-down-long.svg?react';
import ArrowDown from './icons/arrow-down.svg?react';
import ArrowExpand from './icons/arrow-expand.svg?react';
import ArrowRight from './icons/arrow-right.svg?react';
import Backward from './icons/backward.svg?react';
import Bell from './icons/bell.svg?react';
import Blank from './icons/blank.svg?react';
import BlankSelection from './icons/blank_selection_in_component.svg?react';
import Bold from './icons/bold.svg?react';
import BookSetting from './icons/book-setting.svg?react';
import BorderSelect from './icons/border-select.svg?react';
import CancelRed from './icons/cancel-red.svg?react';
import Cancel from './icons/cancel.svg?react';
import Chatter from './icons/chatter.svg?react';
import CheckSave from './icons/check-save.svg?react';
import Check from './icons/check.svg?react';
import CheckboxHover from './icons/checkbox-hover.svg?react';
import CheckboxPressed from './icons/checkbox-pressed.svg?react';
import ChevronRight from './icons/chevron-right.svg?react';
import Clone from './icons/clone.svg?react';
import Close from './icons/close.svg?react';
import ColorBgSelector from './icons/color-bg-selector.svg?react';
import ColorPicker from './icons/color-picker.svg?react';
import ColorSelect from './icons/color-select.svg?react';
import CommentMenu from './icons/comment-menu.svg?react';
import Comment from './icons/comment.svg?react';
import ContentDivider from './icons/content-divider.svg?react';
import ContentIcon from './icons/content-icon.svg?react';
import ContentImage from './icons/content-image.svg?react';
import ContentList from './icons/content-list.svg?react';
import ContentParagraph from './icons/content-paragraph.svg?react';
import ContentSpacer from './icons/content-spacer.svg?react';
import ContentSticker from './icons/content-sticker.svg?react';
import ContentTitle from './icons/content-title.svg?react';
import Copy from './icons/copy.svg?react';
import CopyStyle from './icons/copy_style.svg?react';
import CreateBookLayout1 from './icons/create-book-layout-1.svg?react';
import CreateBookLayout10 from './icons/create-book-layout-10.svg?react';
import CreateBookLayout2 from './icons/create-book-layout-2.svg?react';
import CreateBookLayout3 from './icons/create-book-layout-3.svg?react';
import CreateBookLayout4 from './icons/create-book-layout-4.svg?react';
import CreateBookLayout5 from './icons/create-book-layout-5.svg?react';
import CreateBookLayout6 from './icons/create-book-layout-6.svg?react';
import CreateBookLayout7 from './icons/create-book-layout-7.svg?react';
import CreateBookLayout8 from './icons/create-book-layout-8.svg?react';
import CreateBookLayout9 from './icons/create-book-layout-9.svg?react';
import CreateBookLayout11 from './icons/create-book-layout-11.svg?react';
import CreateBookLayout12 from './icons/create-book-layout-12.svg?react';
import CreateBookLayout13 from './icons/create-book-layout-13.svg?react';
import CreateBookLayout14 from './icons/create-book-layout-14.svg?react';
import CreateBookLayout15 from './icons/create-book-layout-15.svg?react';
import CreateBookLayout16 from './icons/create-book-layout-16.svg?react';
import CreateBookLayout17 from './icons/create-book-layout-17.svg?react';
import CreateBookLayout18 from './icons/create-book-layout-18.svg?react';
import CreateBookLayout19 from './icons/create-book-layout-19.svg?react';
import CreateBookLayout20 from './icons/create-book-layout-20.svg?react';
import CreateBookLayout21 from './icons/create-book-layout-21.svg?react';
import CreateBookLayout22 from './icons/create-book-layout-22.svg?react';
import CreateBookLayout23 from './icons/create-book-layout-23.svg?react';
import CreateBookLayout24 from './icons/create-book-layout-24.svg?react';
import CreateBookLayout25 from './icons/create-book-layout-25.svg?react';
import CreateBookLayout26 from './icons/create-book-layout-26.svg?react';
import CreateBookLayout27 from './icons/create-book-layout-27.svg?react';
import CreateBookLayout28 from './icons/create-book-layout-28.svg?react';
import CreateBookLayout29 from './icons/create-book-layout-29.svg?react';
import CreateBookLayout30 from './icons/create-book-layout-30.svg?react';
import CreateBookLayout31 from './icons/create-book-layout-31.svg?react';
import CreateBookLayout32 from './icons/create-book-layout-32.svg?react';
import CreateBookLayout33 from './icons/create-book-layout-33.svg?react';
import CreateBookLayout34 from './icons/create-book-layout-34.svg?react';
import CreateBookLayout35 from './icons/create-book-layout-35.svg?react';
import CreateBook from './icons/create-book.svg?react';
import Dashboard from './icons/dashboard.svg?react';
import Design from './icons/design.svg?react';
import Document from './icons/document.svg?react';
import DragResize from './icons/drag-resize.svg?react';
import Drag from './icons/drag.svg?react';
import Dropbox from './icons/dropbox.svg?react';
import Duplicate from './icons/duplicate.svg?react';
import EditImage from './icons/edit-image.svg?react';
import Emoji from './icons/emoji.svg?react';
import ErrorCircle from './icons/error-circle.svg?react';
import ExpandLess from './icons/expand-less.svg?react';
import ExpandMoreWhite from './icons/expand-more-white.svg?react';
import ExpandMore from './icons/expand-more.svg?react';
import Expand from './icons/expand.svg?react';
import Eyes from './icons/eye.svg?react';
import EyesWhite from './icons/eyes-white.svg?react';
import Facebook from './icons/facebook.svg?react';
import FillColor from './icons/fill-color.svg?react';
import FlipHorizontally from './icons/flip-horizontally.svg?react';
import FlipVertically from './icons/flip-vertically.svg?react';
import Forward from './icons/forward.svg?react';
import GoogleDrive from './icons/google-drive.svg?react';
import HelpSupport from './icons/help-support.svg?react';
import HighlightBgColor from './icons/hight-bg-color.svg?react';
import ImagePlaceHolder from './icons/image-placeholder.svg?react';
import Indent from './icons/indent.svg?react';
import InfoCircle from './icons/info-circle.svg?react';
import Instagram from './icons/instagram.svg?react';
import Italic from './icons/italic.svg?react';
import LayerPlaceHolder from './icons/layer-placeholder.svg?react';
import LayerPosition from './icons/layer-position.svg?react';
import LayersElement from './icons/layers-element.svg?react';
import Library from './icons/library.svg?react';
import Events from './icons/events.svg?react';
import EventsActive from './icons/events-active.svg?react';
import LibraryNav from './icons/library-nav.svg?react';
import ListBullDefault from './icons/list-bull-default.svg?react';
import ListBullSquere from './icons/list-bull-square.svg?react';
import ListNumDefault from './icons/list-num-default.svg?react';
import ListNumLowerAlpha from './icons/list-num-lower-alpha.svg?react';
import ListNumLowerRoman from './icons/list-num-lower-roman.svg?react';
import ListNumUpperAlpha from './icons/list-num-upper-alpha.svg?react';
import ListNum from './icons/list-num.svg?react';
import LockMenu from './icons/lock-menu.svg?react';
import Lock from './icons/lock.svg?react';
import Logout from './icons/logout.svg?react';
import MainContent from './icons/main-content.svg?react';
import Megaphone from './icons/megaphone.svg?react';
import MyFiles from './icons/my-files.svg?react';
import NavigationLeft from './icons/navigation-left.svg?react';
import NavigationRight from './icons/navigation-right.svg?react';
import NewPosition from './icons/new-position.svg?react';
import Opacity from './icons/opacity.svg?react';
import Outdent from './icons/outdent.svg?react';
import PageLayout from './icons/page-layout.svg?react';
import Plus from './icons/plus.svg?react';
import PopupComment from './icons/popup_comment.svg?react';
import Profile from './icons/profile.svg?react';
import RadioDefault from './icons/radio-default.svg?react';
import RadioSelected from './icons/radio-selected.svg?react';
import Redo from './icons/redo.svg?react';
import TextRedo from './icons/text_redo.svg?react';
import Referral from './icons/referral.svg?react';
import RemoveFormat from './icons/remove-format.svg?react';
import Replace from './icons/replace.svg?react';
import Return from './icons/return.svg?react';
import RotateLeft from './icons/rotate-left.svg?react';
import RotateRight from './icons/rotate-right.svg?react';
import Rotate from './icons/rotate.svg?react';
import RoundDelete from './icons/round-delete.svg?react';
import Search from './icons/search.svg?react';
import Setting from './icons/settings.svg?react';
import Shutterstock from './icons/shutterstock.svg?react';
import Sort from './icons/sort.svg?react';
import StrikeThrough from './icons/strike-through.svg?react';
import SubmitPage from './icons/submit-page.svg?react';
import Subscript from './icons/subscript.svg?react';
import SuccessCircle from './icons/success-circle.svg?react';
import Superscript from './icons/superscript.svg?react';
import TextArt from './icons/text-art.svg?react';
import TextBox from './icons/text-box.svg?react';
import TextColor from './icons/text-color.svg?react';
import ThreeDotBlue from './icons/three-dot-blue.svg?react';
import ThreeDot from './icons/three-dot.svg?react';
import Tick from './icons/tick.svg?react';
import Times from './icons/times.svg?react';
import ToBack from './icons/to-back.svg?react';
import ToFront from './icons/to-front.svg?react';
import Trash from './icons/trash.svg?react';
import Trashbin from './icons/trashbin.svg?react';
import Underline from './icons/underline.svg?react';
import Undo from './icons/undo.svg?react';
import TextUndo from './icons/text_undo.svg?react';
import Unlock from './icons/unlock.svg?react';
import UnorderList from './icons/unordered-list.svg?react';
import UploadPlaceHolder from './icons/upload-placeholder.svg?react';
import Upload from './icons/upload.svg?react';
import UserManagement from './icons/user-management.svg?react';
import WarningCircle from './icons/warning-circle.svg?react';
import WebAddress from './icons/web-address.svg?react';
import SwiperLeft from './icons/swiper-left.svg?react';
import SwiperRight from './icons/swiper-right.svg?react';
import Filter from './icons/filter.svg?react';
import Bug from './icons/bug.svg?react';
import CommentIndicatorBlue from './icons/comment_svg_blue.svg?react';
import CommentIndicatorWhite from './icons/comment_svg_white.svg?react';
import NavigatorComment from './icons/navigator-comment.svg?react';
import CloudSyncIssue from './icons/cloud-sync-issue.svg?react';
import CloudSyncPending from './icons/cloud-sync-pending.svg?react';
import CloudSyncSuccess from './icons/cloud-sync-success.svg?react';
import Quote from './icons/quote.svg?react';
import Info from './icons/info.svg?react';
import Text from './icons/text.svg?react';
import Frames from './icons/frames.svg?react';
import ClipArt from './icons/clipart.svg?react';
import Image from './icons/image.svg?react';
import ImagePlus from './icons/image-plus.svg?react';
import AsRead from './icons/as-read.svg?react';
import AsUnread from './icons/as-unread.svg?react';
import Archive from './icons/archive.svg?react';
import Unarchive from './icons/unarchive.svg?react';
import Drawer from './icons/drawer.svg?react';

import './Icon.scss';

export const ICONS: {
  [key: string]:
    | React.FunctionComponent<
        React.SVGProps<SVGSVGElement> & {
          title?: string;
        }
      >
    | string
    | any;
} = {
  DASHBOARD: Dashboard,
  CLOSE: Close,
  CHECK: Check,
  ERROR_CIRCLE: ErrorCircle,
  INFO_CIRCLE: InfoCircle,
  SUCCESS_CIRCLE: SuccessCircle,
  WARNING_CIRCLE: WarningCircle,
  EXPAND_MORE_WHITE: ExpandMoreWhite,
  EXPAND_MORE: ExpandMore,
  EXPAND_LESS: ExpandLess,
  TIMES: Times,
  SORT: Sort,
  ARROW_DOWN_LONG: ArrowDownLong,
  CHECKBOX_HOVER: CheckboxHover,
  CHECKBOX_PRESSED: CheckboxPressed,
  RADIO_DEFAULT: RadioDefault,
  RADIO_SELECTED: RadioSelected,
  BELL: Bell,
  PROFILE: Profile,
  REFERRAL: Referral,
  USER_MANAGEMENT: UserManagement,
  SETTING: Setting,
  HELP_SUPPORT: HelpSupport,
  ACCOUNT_MANAGEMENT: AccountManagement,
  LIBRARY: Library,
  LIBRARY_NAV: LibraryNav,
  LOGOUT: Logout,
  ARROW_EXPAND: ArrowExpand,
  EYES: Eyes,
  DASHBOARD_IMG: DashboardImg,
  REFERRALS_IMG: ReferralsImg,
  THREE_DOT: ThreeDot,
  TRASH: Trash,
  ARROW_DOWN: ArrowDown,
  CANCEL: Cancel,
  CANCEL_RED: CancelRed,
  PLUS: Plus,
  EYES_WHITE: EyesWhite,
  IMAGE_PLACEHOLDER: ImagePlaceHolder,
  MY_FILES: MyFiles,
  WEB_ADDRESS: WebAddress,
  INSTAGRAM: Instagram,
  FACEBOOK: Facebook,
  SHUTTERSTOCK: Shutterstock,
  GOOGLE_DRIVE: GoogleDrive,
  DROPBOX: Dropbox,
  UPLOAD_PLACEHOLDER: UploadPlaceHolder,
  ARROW_RIGHT: ArrowRight,
  CREATE_BOOK_LAYOUT_1: CreateBookLayout1,
  CREATE_BOOK_LAYOUT_2: CreateBookLayout2,
  CREATE_BOOK_LAYOUT_3: CreateBookLayout3,
  CREATE_BOOK_LAYOUT_4: CreateBookLayout4,
  CREATE_BOOK_LAYOUT_5: CreateBookLayout5,
  CREATE_BOOK_LAYOUT_6: CreateBookLayout6,
  CREATE_BOOK_LAYOUT_7: CreateBookLayout7,
  CREATE_BOOK_LAYOUT_8: CreateBookLayout8,
  CREATE_BOOK_LAYOUT_9: CreateBookLayout9,
  CREATE_BOOK_LAYOUT_10: CreateBookLayout10,
  CREATE_BOOK_LAYOUT_11: CreateBookLayout11,
  CREATE_BOOK_LAYOUT_12: CreateBookLayout12,
  CREATE_BOOK_LAYOUT_13: CreateBookLayout13,
  CREATE_BOOK_LAYOUT_14: CreateBookLayout14,
  CREATE_BOOK_LAYOUT_15: CreateBookLayout15,
  CREATE_BOOK_LAYOUT_16: CreateBookLayout16,
  CREATE_BOOK_LAYOUT_17: CreateBookLayout17,
  CREATE_BOOK_LAYOUT_18: CreateBookLayout18,
  CREATE_BOOK_LAYOUT_19: CreateBookLayout19,
  CREATE_BOOK_LAYOUT_20: CreateBookLayout20,
  CREATE_BOOK_LAYOUT_21: CreateBookLayout21,
  CREATE_BOOK_LAYOUT_22: CreateBookLayout22,
  CREATE_BOOK_LAYOUT_23: CreateBookLayout23,
  CREATE_BOOK_LAYOUT_24: CreateBookLayout24,
  CREATE_BOOK_LAYOUT_25: CreateBookLayout25,
  CREATE_BOOK_LAYOUT_26: CreateBookLayout26,
  CREATE_BOOK_LAYOUT_27: CreateBookLayout27,
  CREATE_BOOK_LAYOUT_28: CreateBookLayout28,
  CREATE_BOOK_LAYOUT_29: CreateBookLayout29,
  CREATE_BOOK_LAYOUT_30: CreateBookLayout30,
  CREATE_BOOK_LAYOUT_31: CreateBookLayout31,
  CREATE_BOOK_LAYOUT_32: CreateBookLayout32,
  CREATE_BOOK_LAYOUT_33: CreateBookLayout33,
  CREATE_BOOK_LAYOUT_34: CreateBookLayout34,
  CREATE_BOOK_LAYOUT_35: CreateBookLayout35,
  CONTENT_TITLE: ContentTitle,
  CONTENT_PARAGRAPH: ContentParagraph,
  CONTENT_IMAGE: ContentImage,
  CONTENT_LIST: ContentList,
  CONTENT_DIVIDER: ContentDivider,
  CONTENT_SPACER: ContentSpacer,
  CONTENT_ICON: ContentIcon,
  CONTENT_STICKER: ContentSticker,
  CREATE_BOOK: CreateBook,
  LOCK: Lock,
  UNLOCK: Unlock,
  NAVIGATION_LEFT: NavigationLeft,
  NAVIGATION_RIGHT: NavigationRight,
  ROTATE_LEFT: RotateLeft,
  ROTATE_RIGHT: RotateRight,
  FLIP_HORIZONTALLY: FlipHorizontally,
  FLIP_VERTICALLY: FlipVertically,
  EDIT_IMAGE: EditImage,
  DRAG: Drag,
  COMMENT: Comment,
  BOLD: Bold,
  ITALIC: Italic,
  UNDERLINE: Underline,
  STRIKETHROUGH: StrikeThrough,
  SUPERSCRIPT: Superscript,
  SUBSCRIPT: Subscript,
  ADVANCED_MENU: AdvancedMenu,
  EMOJI: Emoji,
  TITLE_SELECTION_IMAGE: TitleSelection,
  IMAGE_SELECTION_IMAGE: ImageSelection,
  LIST_SELECTION_IMAGE: ListSelection,
  PARAGRAPH_SELECTION_IMAGE: ParagraphSelection,
  IMAGE_PLACEHOLDER_EDITOR: ImagePlaceholder,
  SUBMIT_PAGE: SubmitPage,
  ROUND_DELETE: RoundDelete,
  CHECK_SAVE: CheckSave,
  UPLOAD: Upload,
  SEARCH: Search,
  HIDDEN_CONTENT: HiddenContent,
  CHATTER: Chatter,
  CHATTER_GREY: ChatterGrey,
  DOCUMENT: Document,
  COLOR_BG_SELECTOR: ColorBgSelector,
  COLOR_PICKER: ColorPicker,
  DESIGN: Design,
  BOOK_SETTING: BookSetting,
  PAGE_LAYOUT: PageLayout,
  MAIN_CONTENT: MainContent,
  LAYERS_ELEMENT: LayersElement,
  TEXT_ART: TextArt,
  LAYER_POSITION: LayerPosition,
  RETURN: Return,
  TEXT_BOX: TextBox,
  BACKGROUND_ICON: BackgroundIcon,
  TICK: Tick,
  ROTATE: Rotate,
  MEGAPHONE: Megaphone,
  EVENTS: Events,
  EVENTS_ACTIVE: EventsActive,
  THREE_DOT_BLUE: ThreeDotBlue,
  BLANK_SELECTION: BlankSelection,
  BLANK: Blank,
  ADD_PAGE: AddPage,
  NEW_POSITION: NewPosition,
  TEXT_COLOR: TextColor,
  HIGHLIGHT_BG_COLOR: HighlightBgColor,
  ALIGN_LEFT: AlignLeft,
  ALIGN_RIGHT: AlignRight,
  ALIGN_JUSTIFY: AlignJustify,
  ALIGN_CENTER: AlignCenter,
  LIST_NUM: ListNum,
  UNORDER_LIST: UnorderList,
  OUTDENT: Outdent,
  INDENT: Indent,
  REMOVE_FORMAT: RemoveFormat,
  UNDO: Undo,
  REDO: Redo,
  TEXT_UNDO: TextUndo,
  TEXT_REDO: TextRedo,
  OPACITY: Opacity,
  LOCK_MENU: LockMenu,
  COMMENT_MENU: CommentMenu,
  BORDER_SELECT: BorderSelect,
  COLOR_SELECT: ColorSelect,
  FILL_COLOR: FillColor,
  LIST_BULL_DEFAULT: ListBullDefault,
  LIST_BULL_SQUERE: ListBullSquere,
  LIST_NUM_DEFAULT: ListNumDefault,
  LIST_NUM_LOWER_ALPHA: ListNumLowerAlpha,
  LIST_NUM_LOWER_ROMAN: ListNumLowerRoman,
  LIST_NUM_UPPER_ALPHA: ListNumUpperAlpha,
  CHEVRON_RIGHT: ChevronRight,
  ALIGNMENT_TOP: AlignmentTop,
  ALIGNMENT_LEFT: AlignmentLeft,
  ALIGNMENT_MIDDLE: AlignmentMiddle,
  ALIGNMENT_CENTRE: AlignmentCentre,
  ALIGNMENT_BOTTOM: AlignmentBottom,
  ALIGNMENT_RIGHT: AlignmentRight,
  FORWARD: Forward,
  BACK_WARD: Backward,
  TO_FRONT: ToFront,
  TO_BACK: ToBack,
  CLONE: Clone,
  LAYER_PLACEHOLDER: LayerPlaceHolder,
  DRAG_RESIZE: DragResize,
  COPY: Copy,
  COPY_STYLE: CopyStyle,
  DUPLICATE: Duplicate,
  POPUP_COMMENT: PopupComment,
  TRASHBIN: Trashbin,
  EXPAND: Expand,
  REPLACE: Replace,
  SWIPER_LEFT: SwiperLeft,
  SWIPER_RIGHT: SwiperRight,
  FILTER: Filter,
  BUG: Bug,
  COMMENT_INDICATOR_BLUE: CommentIndicatorBlue,
  COMMENT_INDICATOR_WHITE: CommentIndicatorWhite,
  NAVIGATOR_COMMENT: NavigatorComment,
  CLOUD_SYNC_ISSUE: CloudSyncIssue,
  CLOUD_SYNC_PENDING: CloudSyncPending,
  CLOUD_SYNC_SUCCESS: CloudSyncSuccess,
  QUOTE: Quote,
  INFO: Info,
  TEXT: Text,
  FRAMES: Frames,
  CLIP_ART: ClipArt,
  IMAGE: Image,
  IMAGE_PLUS: ImagePlus,
  AS_READ: AsRead,
  AS_UNREAD: AsUnread,
  ARCHIVE: Archive,
  UN_ARCHIVE: Unarchive,
  DRAWER: Drawer,
};

export interface IconProps {
  /**
   * Use ICONS constant in Icon.tsx
   */
  component: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
  className?: string;
  size?: IconSize;
  rotation?: number;
  style?: React.CSSProperties;
}

export enum IconSize {
  XS = 'XS',
  SM = 'SM',
  MD = 'MD',
  LG = 'LG',
  XL = 'XL',
  XXL = 'XXL',
  XXXL = 'XXXL',
}

const Icon: React.FC<IconProps> = ({ className, rotation, size = IconSize.SM, component: Component, style }) => {
  const classes = classNames(
    'icon',
    {
      'icon--xs': size === IconSize.XS,
      'icon--sm': size === IconSize.SM,
      'icon--md': size === IconSize.MD,
      'icon--lg': size === IconSize.LG,
      'icon--xl': size === IconSize.XL,
      'icon--xxl': size === IconSize.XXL,
      'icon--xxxl': size === IconSize.XXXL,
    },
    className,
    rotation ? `icon--rotate-${rotation}` : '',
  );

  return <Component className={classes} style={style} />;
};

export default Icon;
